
const filterItem = {
    socialNetwork: '',
    title: "",
    link: "",
    description: ""
}
export default filterItem;